module.exports = __webpack_public_path__ + "fonts/AaHouDiHei.a0cd75ee.ttf";